import { SearchFormInputs } from "../../constants";
import { EditIcon, PassengerIcon, SearchIcon } from "src/assets/Icons";
import { perpareSeachObjectChipValues } from "./utils";
import { explode } from "src/utility/objects";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";

const JourneyChip: FC<{ searchObject: SearchFormInputs } & HTMLAttributes<HTMLDivElement>> = ({
  searchObject,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const { locationLabel, checkinDate, checkoutDate, totalPassengers } = explode(perpareSeachObjectChipValues(searchObject), {});
  return (
    <div className="flex items-center gap-2 ">
      <div>
        <SearchIcon className="h-3 w-3 text-icon-subtle" strokeWidth={2} />
      </div>
      <div className={cn("@container flex w-full flex-1 flex-col gap-1", className)} {...props}>
        <div className="flex items-center justify-start gap-3 text-[clamp(.8rem,1cqw,2rem)] font-semibold">
          <div>{locationLabel}</div>
        </div>
        <div className="flex items-center gap-2 whitespace-nowrap text-font-subtle text-[clamp(.7rem,1cqw,1.7rem)]">
          <div>
            <span className="font-semibold text-font-default">{checkinDate}</span>
            <span className="font-semibold text-font-default"> - {checkoutDate}</span>
          </div>
          <span className="text-font-minimal">|</span>
          <div className="flex items-center gap-1">
            <PassengerIcon className="w-4 h-4" />
            <span>{totalPassengers === 1 ? t("Hotels.common.oneGuest") : t("Hotels.common.guestsCount", { count: totalPassengers })}</span>
          </div>
        </div>
      </div>
      <div>
        <EditIcon />
      </div>
    </div>
  );
};

export default JourneyChip;
